import React from "react";
import { observer } from "mobx-react-lite";
import { Routes, Route } from "react-router-dom";
import { Layout } from "../../layout";
import { SecretList } from "./list";
import { SecretCreate } from "./create";
import { SecretDetailRoute } from "./detailRoute";
import { ConsoleContext } from "../../mobxStores/consoleContext/consoleContext";

const SecretRoute: React.FC = () => {
  const { org } = ConsoleContext;

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<SecretList />} />
        <Route path={`-create/*`} element={<SecretCreate />} />
        <Route path={`:secret/*`} element={<SecretDetailRoute />} />
      </Routes>
    </Layout>
  );
};

export default observer(SecretRoute);
